(function(){
    'use strict';
    
    /*
        JS Usage must follow:
        jcu_js_v1.fn.functionName = function(){
           //do things here 
        }
        jcu_js_v1.vars.variableName = "I am a variable";

    */
   jcu_js_v1.fn.toggleLinkList = function(){

        var toggleBtns = document.querySelectorAll(".jcu-v1__ct__link-list__expand");

        // toggleBtns.forEach(function(btn){
        for(var i=0;i<toggleBtns.length;i++) {
            var btn = toggleBtns[i];

            btn.addEventListener("click", function(){ 
                var parent = this.parentElement;
                if (parent.classList.contains("list-expanded")){
                    // Shrink list
                    parent.classList.remove("list-expanded");
                    this.innerText = "More";
                } else {
                    // Expand list
                    parent.classList.add("list-expanded");
                    this.innerText = "Less"
                }
            });
        };
   }

   jcu_js_v1.fn.toggleLinkList();
    
}());
